module.exports = __webpack_public_path__ + "static/media/kudo.7ed5186c.svg";